export default __webpack_public_path__ + "static/media/staticControl.30c6f503.webp";